<ion-tabs>
  <ion-tab-bar slot="bottom" type="light">
    @for (tab of tabs(); track tab.name) {
      <ion-tab-button
        [class.main]="tab.main"
        [tab]="tab.name">
        <ion-icon [name]="tab.icon"></ion-icon>
        @if (tab.label) {
          <ion-label>{{ tab.label | translate }}</ion-label>
        }
      </ion-tab-button>
    }
  </ion-tab-bar>
</ion-tabs>
